(function () {
	function swiperInit() {
		if (typeof Swiper === 'undefined') {
			return;
		}
		subSliderInit(true, 16);
		sliderInit(true);
		if (typeof popupSliderInit === 'function') {
			popupSliderInit(true);
		}
	}

	function boot() {
		if (window.themeSwiperReady) {
			window.themeSwiperReady.then(swiperInit).catch(function () {});
			return;
		}
		swiperInit();
	}

	document.addEventListener('shopify:section:load', function () {
		boot();
	});

	boot();
})();
